
import ItemAddress from 'pages/inventory-items/detail/ItemAddress';
import React from 'react';
import styles from './index.module.scss';

const RenderInventoryItemAddress = (props) => {
  const { inventoryAddressState, setInventoryItemState, originalInventoryAddress, setShowAddressEdit } = props;

  const handleAddressChange = (key: string, addressObject: Record<string, any>) => {
    if (key === 'start') {
      setInventoryItemState({
        start: addressObject,
        end: addressObject,
      });
    } else {
      setInventoryItemState({
        ...inventoryAddressState,
        [key]: addressObject,
      });
    }
  };

  return (
    <>
      <div className={styles['main-container-inventoryaddress-modal']}>
        <div className={styles['modal-container']}>
          <div className={styles['modal-header']}>
            <div>
              <div className={styles['label']}>Edit Inventory Address</div>
            </div>
            <i className={'fa fa-times'} onClick={() => setShowAddressEdit(false)} />
          </div>
          <div className={styles['modal-body']}>
            <div className={styles['inventory-address']}>
              <div>
                <ItemAddress
                  addressType={'Start'}
                  inventoryAddress={inventoryAddressState?.start}
                  editInfo={true}
                  loading={false}
                  setAddress={handleAddressChange}
                />
              </div>
              <div>
                <ItemAddress
                  addressType={'End'}
                  inventoryAddress={inventoryAddressState?.end}
                  editInfo={true}
                  loading={false}
                  setAddress={handleAddressChange}
                />
              </div>
            </div>
          </div>
          <div className={styles['modal-footer']}>
            <button
              className={styles['cancel-button']}
              onClick={() => {
                setInventoryItemState(originalInventoryAddress);
                setShowAddressEdit(false);
              }
              }
            >
              Cancel
            </button>
            <button
              className={styles['submit-button']}
              onClick={() => setShowAddressEdit(false)}
            >
              Update Address
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default RenderInventoryItemAddress;